import { fetchWithCache, getCachedData } from "../services/apiService";

export const titleCompanySearch = async (
  business_name,
  { setTitleResults },
) => {
  const cacheKey = `/api/user/titleSearch_${business_name}`;

  // Show cached data immediately if available
  const cached = getCachedData(cacheKey, {});
  if (cached) {
    setTitleResults(cached);
  }

  try {
    const data = await fetchWithCache(
      "/api/user/titleSearch",
      {
        method: "POST",
        body: JSON.stringify({ business_name }),
        cacheKey,
        retries: 2,
        timeout: 10000,
      },
      true,
    );
    setTitleResults(data);
  } catch (err) {
    if (!cached) {
      setTitleResults([]);
    }
  }
};
